import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    logo: {
      width: 180,
    },
    gridBannerPromotion: {
      marginTop: '15px!important',
      marginBottom: '15px!important',
    },
    bannerPromotion: {
      width: '90%',
      objectFit: 'cover',
      borderRadius: 5,
    },
    bannerShop: {
      width: 80,
      objectFit: 'cover',
      borderRadius: 5,
    },
    gridBannerPromotionDescription: {
      marginTop: '-30px!important',
      backgroundColor: '#fff',
      boxShadow:
        '0px 0px 10px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)!important',
      width: '85%!important',
      borderRadius: 10,
      padding: '1px 0px 0 0px',
    },
    gridBannerPromotionTitle: {
      margin: '0px 0 0 0',
      color: '#292d32',
    },
    gridBannerPromotionValue: {
      backgroundColor: '#a51713',
      borderRadius: 10,
      color: '#fff',
      padding: '0px 0px',
    },
    gridBannerPromotionValueText: {
      fontSize: 10,
      margin: '10px 0 0 0',
    },
    gridBannerPromotionValuePriceTotal: {
      display: 'flex',
      justifyContent: 'center',
    },
    gridBannerPromotionValueDollarSign: {
      fontSize: 12,
      margin: '0px 0 0 0',
    },
    gridBannerPromotionValueDefault: {
      backgroundColor: '#c5720b',
      borderRadius: '10px 10px 0 0',
      color: '#fff',
      fontSize: 12,
      margin: '0px!important',
    },
    gridBannerPromotionValuePrice: {
      fontSize: 15,
      margin: '0px 0 0 5px',
      padding: 0,
    },
    gridBannerPromotionValueCents: {
      margin: '-3px 0 0 0',
      fontSize: 12,
    },

    textTagLive: {
      margin: '0px!important',
      backgroundColor: '#298000',
      borderRadius: 5,
      height: 20,
      padding: '0px 10px',
      color: '#fff',
      alignItems: 'center',
      textTransform: 'uppercase',
      fontWeight: 550,
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: 12,
    },
  }),
);

export default useStyles;
